// src/services/api.js

import createApiClient from './apiClient';
import imdbApi from './apis/imdbApi';
import tmdbApi from './apis/tmdbApi';
import s1Api from './apis/s1Api';
import s2Api from './apis/s2Api';
import s3Api from './apis/s3Api';
import securityApi from './apis/securityApi';
import paymentApi from './apis/paymentApi';
import favoritesApi from './apis/favoritesApi';

const apiClient = createApiClient();

const apis = {
  Imdb: imdbApi(apiClient),
  Tmdb: tmdbApi(apiClient),
  S1: s1Api(apiClient),
  S2: s2Api(apiClient),
  S3: s3Api(apiClient),
  Security: securityApi(apiClient),
  Payment: paymentApi(apiClient),
  Favorites: favoritesApi(apiClient), 
};

export default apis;
